(function () {
  'use strict';

  var config = window.GF_MOTION || {};
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var loaded = false;

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function showAllContent() {
    document.documentElement.classList.remove('gf-motion-pending');
    document.documentElement.classList.add('gf-motion-ready');
  }

  function loadMotion() {
    if (loaded || !config.gsap || !config.scrollTrigger || !config.deferred) return;
    loaded = true;

    loadScript(config.gsap)
      .then(function () { return loadScript(config.scrollTrigger); })
      .then(function () { return loadScript(config.deferred); })
      .catch(function (err) {
        console.warn('GF motion load failed:', err);
        showAllContent();
      });
  }

  function collectMotionTriggers() {
    var hero = document.querySelector('[data-gf-hero]');
    var selectors = [
      '[data-gf-feature]',
      '[data-gf-results]',
      '[data-gf-lazy-section]',
      '.gf-pulse-rings',
      '.gf-ecg-line'
    ];
    var nodes = [];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (hero && hero.contains(el)) return;
        nodes.push(el);
      });
    });

    document.querySelectorAll('.gf-reveal').forEach(function (el) {
      if (hero && hero.contains(el)) return;
      if (nodes.indexOf(el) === -1) nodes.push(el);
    });

    return nodes;
  }

  function scheduleMotion() {
    if (prefersReduced) {
      showAllContent();
      return;
    }

    if (document.documentElement.classList.contains('shopify-design-mode')) {
      loadMotion();
      return;
    }

    var triggers = collectMotionTriggers();
    if (!triggers.length || !('IntersectionObserver' in window)) {
      showAllContent();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            loadMotion();
            observer.disconnect();
            return;
          }
        }
      },
      { rootMargin: '0px 0px', threshold: 0.01 }
    );

    triggers.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleMotion);
  } else {
    scheduleMotion();
  }
})();
